import React from 'react';
import PropTypes from 'prop-types';

import defaultImage from 'images/sleuth-og.webp';
import useSiteMetadata from 'hooks/useSiteMetadata';

function SEO({
  canonical,
  description,
  hrefLang,
  imageUrl,
  location,
  schema,
  title: _title,
}) {
  let title = _title;
  if (!/(^Sleuth\b|\bSleuth$)/i.test(title)) {
    title = `${title} | Sleuth`;
  }

  const { siteUrl } = useSiteMetadata();

  const url = new URL(location.pathname, siteUrl);
  const image = new URL(imageUrl, siteUrl).toString();
  const schemaString = schema && JSON.stringify(schema, null, 2);

  return (
    <>
      <html lang="en" />
      <link rel="alternate" href={hrefLang || url.href} hrefLang="en" />

      <title>{title}</title>
      <meta name="description" content={description} />

      {/* Open graph tags */}
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:title" content={title} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url.href} />

      {/* Twitter card tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:creator" content="@sleuth_io" />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:domain" content={url.hostname} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:site" content="@sleuth_io" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:url" content={url.href} />

      {/* Canonical url */}
      <link rel="canonical" href={canonical || url.href} />

      {/* Schema */}
      {schema && <script type="application/ld+json">{schemaString}</script>}
    </>
  );
}

SEO.propTypes = {
  canonical: PropTypes.string,
  children: PropTypes.any,
  description: PropTypes.string,
  hrefLang: PropTypes.string,
  imageUrl: PropTypes.string,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  schema: PropTypes.object,
  title: PropTypes.string,
};

SEO.defaultProps = {
  description:
    'Engineering alignment and execution with Sleuth: Reviews and DORA Metrics',
  children: null,
  imageUrl: defaultImage,
  title: 'Reviews | DORA Metrics',
};

export default SEO;
